"use strict";
import Rails from "@rails/ujs";
Rails.start();
window.Rails = Rails;
